import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "home",
  style: {"min-height":"100%"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { style: {"margin-bottom":"0px"} }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "column" }
const _hoisted_15 = ["rows", "onUpdate:modelValue", "id"]
const _hoisted_16 = { class: "column" }
const _hoisted_17 = { style: {"max-width":"100px"} }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Copy ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { style: {"color":"grey"} }, " Copied to clipboard: ", -1)
const _hoisted_23 = { style: {"font-size":"18px"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { style: {"color":"grey"} }, " click to hide ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.file === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createNew && _ctx.createNew(...args)))
            }, "Create New"),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
            }, "Clear Localstorage"),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadFileFromJson && _ctx.loadFileFromJson(...args)))
            }, "Load Backup")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addCategory && _ctx.addCategory(...args)))
              }, "Add Entry"),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
              }, "Clear Localstorage"),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveFileToJson && _ctx.saveFileToJson(...args)))
              }, "Backup")
            ]),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.file.categories, (entry) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: entry.id,
                  href: '#' + entry.id
                }, [
                  _createElementVNode("button", {
                    class: "color-button",
                    style: _normalizeStyle({borderColor: entry.color})
                  }, _toDisplayString(entry.name), 5)
                ], 8, _hoisted_4))
              }), 128))
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.file.categories, (entry) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "category-container",
              style: _normalizeStyle([{}, {borderColor: entry.color}]),
              key: entry.id,
              id: entry.id
            }, [
              _createElementVNode("h4", null, [
                _createTextVNode(_toDisplayString(entry.name) + " ", 1),
                _createElementVNode("small", null, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.addSnippet(entry.id))
                  }, "+", 8, _hoisted_6),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.renameCategory(entry.id))
                  }, "Rename", 8, _hoisted_7),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.moveCategory(entry.id, -1))
                  }, "↑", 8, _hoisted_8),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.moveCategory(entry.id, 1))
                  }, "↓", 8, _hoisted_9),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.deleteCategory(entry.id))
                  }, "Delete", 8, _hoisted_10)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.snippets, (field, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_11, [
                      _createElementVNode("b", null, _toDisplayString(field.name), 1),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.deleteSnippet(entry.id, field.id))
                      }, "Delete", 8, _hoisted_12)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("textarea", {
                          rows: Math.max(field.content.split(/\r\n|\r|\n/).length, 4),
                          cols: "100",
                          "onUpdate:modelValue": ($event: any) => ((field.content) = $event),
                          onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
                          id: 'textarea'+field.id
                        }, null, 40, _hoisted_15), [
                          [_vModelText, field.content]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.moveSnippet(entry.id, field.id, -1))
                          }, "↑", 8, _hoisted_18),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.moveSnippet(entry.id, field.id, 1))
                          }, "↓", 8, _hoisted_19),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.copyValueToClipboard(field.content)),
                            style: {"font-size":"30px"}
                          }, [
                            _createVNode(_component_ion_icon, { name: "copy-outline" }),
                            _hoisted_21
                          ], 8, _hoisted_20)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ], 12, _hoisted_5))
          }), 128))
        ])),
    (_ctx.flash_text)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "flash",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.flash_text=null))
        }, [
          _hoisted_22,
          _createElementVNode("pre", _hoisted_23, _toDisplayString(_ctx.flash_text), 1),
          _hoisted_24
        ]))
      : _createCommentVNode("", true)
  ]))
}